import { render, staticRenderFns } from "./LoginRegister.vue?vue&type=template&id=31eeafbc&scoped=true"
import script from "./LoginRegister.vue?vue&type=script&lang=js"
export * from "./LoginRegister.vue?vue&type=script&lang=js"
import style0 from "./LoginRegister.vue?vue&type=style&index=0&id=31eeafbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eeafbc",
  null
  
)

export default component.exports